import * as React from 'react';
import { api } from '@/lib/api';

/** base64 (from `/jd/preview`) → object URL; revoked when the value changes or on unmount. */
export function useBase64ObjectUrl(base64: string | null, mimeType = 'application/pdf'): string | null {
  const [url, setUrl] = React.useState<string | null>(null);
  React.useEffect(() => {
    if (!base64) {
      setUrl(null);
      return;
    }
    let objectUrl: string | null = null;
    try {
      const bin = atob(base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      objectUrl = URL.createObjectURL(new Blob([bytes], { type: mimeType }));
      setUrl(objectUrl);
    } catch {
      setUrl(null);
    }
    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [base64, mimeType]);
  return url;
}

/** Trigger a download of an authenticated file (`/files/:id/content?download=1`). */
export async function downloadFile(fileId: string, name: string): Promise<void> {
  const blob = await api.blob(`/files/${fileId}/content`, { query: { download: 1 } });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
